import React from "react";

import {
    Edit,
    DateInput,
    TextInput,
    NumberInput,
    ReferenceInput,
    SelectInput,
    SimpleForm,
} from "react-admin";

const today = new Date();

const SampleEdit = (props) => {
    return (
        <Edit undoable={false} {...props}>
            <SimpleForm defaultValue={{ createad_at: today }}>
                <DateInput source="collection_date" />
                <TextInput source="sample" />
                <TextInput source="description" />
                <TextInput source="code" />
                <NumberInput source="longitude" />
                <NumberInput source="latitude" />
                <SelectInput
                    source="source"
                    choices={[
                        { id: "Water", name: "Water" },
                        { id: "Environment", name: "Environment" },
                        { id: "Health Facilities", name: "Health Facilities" },
                        { id: "Other", name: "Other" },
                    ]}
                />
                <TextInput source="sampling_site" />


                <ReferenceInput
                    perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
                    label="Catalog sample"
                    source="id_catalog_sample"
                    reference="catalog_samples"
                    allowEmpty
                >
                    <SelectInput optionText="short_description" />
                </ReferenceInput>

                <ReferenceInput
                    perPage={999999} // FIXME: This is a hack to avoid the "perPage" error
                    label="Provider"
                    source="id_provider"
                    reference="providers"
                >
                    <SelectInput optionText="name" />
                </ReferenceInput>
                <TextInput
                    fullWidth
                    source="notes"
                    label="Notes"
                    multiline
                    minRows={6}
                />
            </SimpleForm>
        </Edit>
    );
};

export default SampleEdit;
